import { createSlice } from "@reduxjs/toolkit";
import { APIINTEGRATION } from "../../../constants/reducer_names";



const initialState: any = {
    clientRowList: '',
    domainRowList: '',
    domainDetails: '',
    endPointDetails: '',
    domainResponse: '',

} as any;

const apiIntegrationSlice = createSlice({
    name: APIINTEGRATION,
    initialState,
    reducers: {
        setClientRowList: (state, { payload }) => {
            state.clientRowList = payload.clientRowList
        },
        setDomainRowList: (state, { payload }) => {
            state.domainRowList = payload.domainRowList
        },
        setDomainDetails: (state, { payload }) => {
            state.domainDetails = payload.domainDetails
        },
        setEndPointDetails: (state, { payload }) => {
            state.endPointDetails = payload.endPointDetails
        },
        setDomainResponse: (state, { payload }) => {
            state.domainResponse = payload.domainResponse
        },
    }
});


export const apiIntegrationActions = apiIntegrationSlice.actions;
export default apiIntegrationSlice.reducer;